import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const DiscoverContractsViewChunk = lazy(() =>
  import('@webapp/modules/purchasing/feature-sets/DiscoverContractsView').then(
    ({ DiscoverContractsView }) => ({
      default: DiscoverContractsView,
    })
  )
)

export const DiscoverContractsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.discoverContractsPageTitle)}
      breadcrumbs={[]}
    >
      <DiscoverContractsViewChunk />
    </Page>
  )
}

DiscoverContractsPage.displayName = 'DiscoverContractsPage'
